var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "tplx",
                    expression: "'tplx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "tplx",
                  required: _vm.isRequired("tplx"),
                  rules: _vm.getRules("tplx"),
                  value: _vm.formData.tplx,
                  label: "退票类型",
                  placeholder: "退票类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.tplx,
                            placeholder: "退票类型",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.tplx, "tplx")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.tplx.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.tplx, "show", $$v)
                              },
                              expression: "tplx.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择退票类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.tplx.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("tplx")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.tplx)
                                },
                              },
                              model: {
                                value: _vm.tplx.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tplx, "filterText", $$v)
                                },
                                expression: "tplx.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "tplx",
                              attrs: { columns: _vm.tplx.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.tplx.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sy",
                    expression: "'sy'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("sy"),
                  required: _vm.isRequired("sy"),
                  name: "sy",
                  rules: _vm.getRules("sy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "事由",
                  "show-word-limit": "",
                  placeholder: "请输入事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.sy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sy", $$v)
                  },
                  expression: "formData.sy",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bz",
                    expression: "'bz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("bz"),
                  required: _vm.isRequired("bz"),
                  rules: _vm.getRules("bz"),
                  name: "bz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bz", $$v)
                  },
                  expression: "formData.bz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "原始发票",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "relativeFlow",
                  expression: "'relativeFlow'",
                },
              ],
            },
            [
              _c(
                "van-row",
                {
                  staticClass: "m-t-26 m-b-26",
                  attrs: { type: "flex", align: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "font-32 font-weight-500 cor-00" },
                      [_vm._v("关联开票流程")]
                    ),
                  ]),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      !_vm.isDisabled("relativeFlow")
                        ? _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加审批单",
                            },
                            on: { click: _vm.addSpd },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.relativeFlow.length === 0
                ? _c("van-cell-group", { staticClass: "text-center p-20" }, [
                    _c("img", {
                      staticClass: "w-300 h-300",
                      attrs: { src: `${_vm.image_base_url}/null.png` },
                    }),
                    _c("div", { staticClass: "font-24 cor-8B m-t-20" }, [
                      _vm._v("暂无关联流程，请点击“添加审批单”关联~"),
                    ]),
                  ])
                : _vm._l(_vm.formData.relativeFlow, function (item, index) {
                    return _c(
                      "van-cell-group",
                      { key: index, staticClass: "b-r-10 m-t-20 p-20" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex col-center row-between" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "f-show",
                                    rawName: "v-f-show",
                                    value: "relativeFlow",
                                    expression: "'relativeFlow'",
                                  },
                                ],
                                staticClass:
                                  "font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "relativeFlow")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("流程状态"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.businessStatusName) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("申请时间"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.startTime
                                          ? _vm
                                              .moment(item.startTime)
                                              .format("YYYY-MM-DD")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("完成时间"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.endTime
                                          ? _vm
                                              .moment(item.endTime)
                                              .format("YYYY-MM-DD")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("摘要"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c("div", { staticClass: "cor-33 font-30" }, [
                                _vm._v(" " + _vm._s(item.summary) + " "),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
        [_vm._v("流程")]
      ),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            attrs: {
              actCurrentNode: _vm.processData.actCurrentNode || "",
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            attrs: { processData: _vm.processData, formData: _vm.formData },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-35", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("relativeFlow", {
        attrs: { show: _vm.relativeFlow.show, groupId: "7" },
        on: {
          finish: _vm.relativeFlowFinish,
          close: function ($event) {
            _vm.relativeFlow.show = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }